import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone, MessageCircle, CheckCircle } from 'lucide-react';
import { dogInfo, images, contactInfo } from '../data/mock';

const Reproducteur = () => {
  return (
    <div className="min-h-screen bg-black pt-20">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={images.hero}
            alt="Tarzan"
            className="w-full h-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black"></div>
        </div>
        <div className="relative z-10 container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            <span className="text-[#cbb26a]">{dogInfo.name}</span>
          </h1>
          <p className="text-xl text-white/90">Mâle Reproducteur Labrador Chocolat LOF</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          {/* Presentation */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white mb-6">
              Présentation de <span className="text-[#cbb26a]">{dogInfo.name}</span>
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <p className="text-white/80 text-lg mb-6 leading-relaxed">
                  {dogInfo.name} est un superbe Labrador chocolat LOF de {dogInfo.age} ans. {dogInfo.description}, il présente toutes les qualités physiques et comportementales 
                  recherchées chez un reproducteur d'exception. Numéro de LOF : 302129/29378
                </p>
                <p className="text-white/80 text-lg leading-relaxed">
                  {dogInfo.character}
                </p>
              </div>
              <img
                src={images.gallery[3]}
                alt="Tarzan portrait"
                className="w-full h-80 object-cover rounded-lg"
              />
            </div>
          </div>

          {/* Caracteristiques physiques */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white mb-6">
              Caractéristiques <span className="text-[#cbb26a]">physiques</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardContent className="p-6">
                  <div className="text-[#cbb26a] font-semibold mb-2">Âge</div>
                  <div className="text-2xl font-bold text-white">{dogInfo.age} ans</div>
                </CardContent>
              </Card>
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardContent className="p-6">
                  <div className="text-[#cbb26a] font-semibold mb-2">Poids</div>
                  <div className="text-2xl font-bold text-white">{dogInfo.weight} kg</div>
                </CardContent>
              </Card>
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardContent className="p-6">
                  <div className="text-[#cbb26a] font-semibold mb-2">Hauteur au dos</div>
                  <div className="text-2xl font-bold text-white">{dogInfo.heightBack} cm</div>
                </CardContent>
              </Card>
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardContent className="p-6">
                  <div className="text-[#cbb26a] font-semibold mb-2">Longueur</div>
                  <div className="text-2xl font-bold text-white">{dogInfo.length} cm</div>
                </CardContent>
              </Card>
            </div>
            <Card className="bg-white/5 border-[#cbb26a]/30 mt-6">
              <CardContent className="p-6">
                <div className="text-[#cbb26a] font-semibold mb-3">Morphologie</div>
                <p className="text-white/80">
                  {dogInfo.description} avec une structure osseuse solide. Hauteur aux épaules : {dogInfo.heightShoulder}. 
                  De la truffe à la pointe de la queue : {dogInfo.length} cm. Morphologie parfaitement conforme au standard LOF.
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Photos */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white mb-6">
              Galerie <span className="text-[#cbb26a]">photos</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {images.gallery.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Tarzan ${index + 1}`}
                  className="w-full h-64 object-cover rounded-lg hover:scale-105 transition-transform duration-300"
                />
              ))}
            </div>
          </div>

          {/* Pedigree */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white mb-6">
              <span className="text-[#cbb26a]">Pedigree</span> LOF
            </h2>
            <Card className="bg-white/5 border-[#cbb26a]/30">
              <CardContent className="p-6">
                <div className="overflow-x-auto">
                  <table className="w-full text-white">
                    <tbody>
                      <tr className="border-b border-[#cbb26a]/20">
                        <td className="py-3 font-semibold text-[#cbb26a]">Père</td>
                        <td className="py-3">{dogInfo.pedigree.father}</td>
                      </tr>
                      <tr className="border-b border-[#cbb26a]/20">
                        <td className="py-3 pl-8 text-white/70">Grand-père paternel</td>
                        <td className="py-3">{dogInfo.pedigree.grandfather_p}</td>
                      </tr>
                      <tr className="border-b border-[#cbb26a]/20">
                        <td className="py-3 pl-8 text-white/70">Grand-mère paternelle</td>
                        <td className="py-3">{dogInfo.pedigree.grandmother_p}</td>
                      </tr>
                      <tr className="border-b border-[#cbb26a]/20">
                        <td className="py-3 font-semibold text-[#cbb26a]">Mère</td>
                        <td className="py-3">{dogInfo.pedigree.mother}</td>
                      </tr>
                      <tr className="border-b border-[#cbb26a]/20">
                        <td className="py-3 pl-8 text-white/70">Grand-père maternel</td>
                        <td className="py-3">{dogInfo.pedigree.grandfather_m}</td>
                      </tr>
                      <tr>
                        <td className="py-3 pl-8 text-white/70">Grand-mère maternelle</td>
                        <td className="py-3">{dogInfo.pedigree.grandmother_m}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Tests de sante */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-white mb-6">
              Tests de <span className="text-[#cbb26a]">santé</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardHeader>
                  <CardTitle className="text-[#cbb26a]">Résultats des tests</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    <div className="flex items-center space-x-3">
                      <CheckCircle className="text-[#cbb26a]" size={24} />
                      <div>
                        <div className="text-white font-semibold">Dysplasie (hanches et coudes)</div>
                        <div className="text-white/70 text-sm">{dogInfo.health.dysplasia}</div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <CheckCircle className="text-[#cbb26a]" size={24} />
                      <div>
                        <div className="text-white font-semibold">Tests ADN</div>
                        <div className="text-white/70 text-sm">{dogInfo.health.dna}</div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <CheckCircle className="text-[#cbb26a]" size={24} />
                      <div>
                        <div className="text-white font-semibold">Examens ophtalmologiques</div>
                        <div className="text-white/70 text-sm">{dogInfo.health.eyes}</div>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <CheckCircle className="text-[#cbb26a]" size={24} />
                      <div>
                        <div className="text-white font-semibold">Vaccinations</div>
                        <div className="text-white/70 text-sm">{dogInfo.health.vaccinations}</div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
              <Card className="bg-white/5 border-[#cbb26a]/30">
                <CardHeader>
                  <CardTitle className="text-[#cbb26a]">Exigences pour la femelle</CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3 text-white/80">
                    <li className="flex items-start space-x-2">
                      <span className="text-[#cbb26a] mt-1">•</span>
                      <span>Certificat LOF obligatoire</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-[#cbb26a] mt-1">•</span>
                      <span>Vaccins à jour (CHLRP + rage)</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-[#cbb26a] mt-1">•</span>
                      <span>Test de brucellose (moins de 2 mois)</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-[#cbb26a] mt-1">•</span>
                      <span>Tests de dysplasie recommandés</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-[#cbb26a] mt-1">•</span>
                      <span>Âge : entre 2 et 7 ans</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-[#cbb26a] mt-1">•</span>
                      <span>Bonne santé générale</span>
                    </li>
                  </ul>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <h3 className="text-2xl font-bold text-white mb-6">Intéressé par une saillie ?</h3>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                asChild
                size="lg"
                className="bg-[#cbb26a] text-black hover:bg-[#d4c485] transition-all duration-300"
              >
                <a href={`https://wa.me/33${contactInfo.whatsapp.substring(1)}`} className="flex items-center space-x-2">
                  <MessageCircle size={20} />
                  <span>WhatsApp</span>
                </a>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-[#cbb26a] text-white hover:bg-[#cbb26a]/10 transition-all duration-300"
              >
                <a href={`tel:${contactInfo.phone}`} className="flex items-center space-x-2">
                  <Phone size={20} />
                  <span>{contactInfo.phone}</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reproducteur;